module.exports = __webpack_public_path__ + "img/userCaseNav3.1f8e1288.png";